import _ from 'lodash';

export default function(ngModule) {
    ngModule.factory('EventLocation', function(BaseClass,$q, $http, ErrorRejector) {
        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function EventLocation(attributes) {
            _.assign(this,attributes);
        }
        EventLocation.modelName = 'EventLocation';

        BaseClass.apply(EventLocation);
        EventLocation.configureApi('/location/:guid', { queryAdmin: '/location/:status/:company', reinstate: '/location/:guid/reinstate' });
        EventLocation.hasMany('EventLocation', 'children', 'parent_guid', '/location/:guid/children');
        EventLocation.hasMany('EventDate', 'dates', 'location_id', '/location/:guid/dates');

        EventLocation.configureAPIMessages({
            '/location/:guid/parent/:parent_guid': {
                422: 'models.location.notice.circular'
            }
        });

        /**
         * Set location parent
         *
         * A location can have several sub-locations, e.g. Stage 3 at Hal A. Use this function to
         * create a tree of locations. WARNING: You can't create a circular tree A>B>C>A
         *
         * @param {String} parentGuid GUID of parent location
         * @throws {LocationCircularError} if settings this parent will create a self-referencing tree
         * @return {EventLocation} Promise to deliver child location
         */
        EventLocation.prototype.$setParent = function(parentGuid) {
            return $http.get(`/location/${this.guid}/parent/${parentGuid}`).then( res => {

                return $http.post(res.config.url);
            }, () => {
                return $q.reject(new LocationCircularError());
            }).then( () => {
                return $q.resolve(this);
            });
        };

        /**
         * Retrieve parent location
         *
         * @return {EventLocation} Promise
         */
        EventLocation.prototype.$getParent = function() {
            return $http.get(`/location/${this.guid}/parent`).then( res => EventLocation.new(res.data) );
        };

        /**
         * Remove parent relation
         *
         * @return {EventLocation} Promise to deliver original location
         */
        EventLocation.prototype.$deleteParent = function() {
            return $http.delete(`/location/${this.guid}/parent`).then( res => {
                return $q.resolve(this);
            });
        };

        /**
         * Retrieve trashed locations, must be admin
         *
         * @param {integer} companyId The guid of the company who's locations we're interested in
         * @param {bool} only Optional, defaults to true. Retrieve ONLY trashed locations, not all locations including trashed
         * @return {EventLocation[]} Array of locations
         */
        EventLocation.getTrashed = function(companyId, only) {
            only = only === false ? 'trashed' : 'justTrashed';
            return $http.get(`/location/${companyId}/${only}`).then( res => _.map( res.data, EventLocation.new ));
        };

        /**
         * Reinstate a previously deleted location
         *
         * @return {EventLocation} Promise
         */
        EventLocation.prototype.$reinstate = function() {
            return $http.post(`/location/${this.guid}/reinstate`).then( res => {
                return $q.resolve(this);
            });
        };

        /**
         * Create event
         *
         * An event can (should) have a location
         *
         * @param {Event} event Event model to save
         * @throws {LocationCircularError} if settings this parent will create a self-referencing tree
         * @return {EventLocation} Promise to deliver child location
         */
        EventLocation.prototype.$createEvent = function(event) {
            if(_.isUndefined(this.constructor.api)) {
                return ErrorRejector.handle('Cannot move new event to a location');
            }

            let url = `${this.$compileUrl()}/event`;
            let data = _.defaults({}, event);

            return $http.post(url, data)
                .then(response => {
                    this.broadcastAPIMessage(response);

                    _.assign(event, response.data);

                    event.$savedState = _.cloneDeep(event);
                    event.constructor.cache(event);

                    return event;
                })
                .catch(error => {
                    console.error('Failed to save event', error);

                    this.broadcastAPIMessage(error);

                    return $q.reject(error);
                });
        };

        EventLocation.prototype.toString = function() {
            return this.name;
        };

        EventLocation.validates({
            name: {
                required: true
            },
            capacity: {
                required: true,
                integer: true
            },
            company_id: {
            },
            latitude: {
                numericality: true
            },
            longitude: {
                numericality: true
            },
            public: {
                bool: {
                    validator: function(value) {
                        return value === true || value === false;
                    },
                    message: 'not a valid input'
                }
            }
        });

        function LocationCircularError() {
            this.message = 'Setting this parent would create a circular location structure, not allowed';
            this.name = 'LocationCircularError';
        }
        LocationCircularError.prototype = new Error();

        return EventLocation;

    });
}
